import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useOutsideClick } from '@redneckz/uni-jsx/lib/hooks/useOutsideClick';
import { getYears } from './getYears.js';
import { months } from './months.js';
const MONTHS_COUNT = 11;
const MONTHS_OPTIONS = months.map((key) => ({ key }));
const YEARS_OPTIONS = getYears()
    .reverse()
    .map((key) => ({ key: String(key) }));
export const useDatePickerManager = ({ onShowCalendar, showCalendar, selectedMonth, onMonthSelect, onYearSelect, selectedYear, }) => {
    const close = useCallback(() => showCalendar && onShowCalendar(false), [showCalendar]);
    const ref = useOutsideClick(close);
    const handleChangeVisibleCalendar = useCallback(() => onShowCalendar(!showCalendar), [showCalendar]);
    const handleNextMonth = useCallback(() => {
        if (selectedMonth + 1 <= MONTHS_COUNT) {
            onMonthSelect(selectedMonth + 1);
        }
        else {
            onMonthSelect(0);
            onYearSelect(selectedYear + 1);
        }
    }, [selectedMonth]);
    const handlePrevMonth = useCallback(() => {
        if (selectedMonth - 1 >= 0) {
            onMonthSelect(selectedMonth - 1);
        }
        else {
            onMonthSelect(11);
            onYearSelect(selectedYear - 1);
        }
    }, [selectedMonth]);
    const handleSelectMonth = useCallback(({ key }) => onMonthSelect(months.indexOf(key)), []);
    const handleSelectYear = useCallback(({ key }) => onYearSelect(Number(key)), []);
    return {
        handleChangeVisibleCalendar,
        handleNextMonth,
        handlePrevMonth,
        handleSelectMonth,
        handleSelectYear,
        monthsOptions: MONTHS_OPTIONS,
        yearsOptions: YEARS_OPTIONS,
        ref,
    };
};
//# sourceMappingURL=useDatePickerManager.js.map